<template>

  <v-menu :close-on-content-click="false">

    <template v-slot:activator="{ props }">
      <v-btn color="app-bar-item-foreground" icon v-bind="props" class="mr-4">
        <v-icon icon="$settings" />
        <v-tooltip
          activator="parent"
          location="top"
        >{{ $t('titles.preferences') }}</v-tooltip>
      </v-btn>
    </template>

    <v-list>

      <v-list-item>
        <o-switch
          :label="$t('titles.dark_mode')"
          v-model="PreferencesService.preferences.darkMode"
          hide-details
        />
      </v-list-item>

      <v-list-item v-if="canSeeIds">
        <o-switch
          :label="$t('titles.show_ids')"
          v-model="PreferencesService.preferences.showIds"
          hide-details
        />
      </v-list-item>

      <!-- commented out until we get some translations -->
      <!--
      <v-list-item>
        <o-select
          :label="$t('titles.language')"
          :items="languageOptions"
          v-model="PreferencesService.preferences.locale"
        />
      </v-list-item>
      -->

      <!--
      <v-list-item>
        <o-select
          :label="$t('titles.time_zone')"
          :items="timezoneOptions"
          v-model="PreferencesService.preferences.timezone"
        />
      </v-list-item>
      -->

    </v-list>

  </v-menu>

</template>

<script setup lang="ts">

import { inject, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useTheme } from 'vuetify'
import PreferencesService from '../services/PreferencesService'
import type { Can } from '../main'
// import moment from 'moment-timezone'

const theme = useTheme()
const i18n = useI18n()

const $can = inject('$can') as Can
const canSeeIds = $can('seeids')

// const languageOptions = i18n.availableLocales.map((locale) => {
//   return {
//     value: locale,
//     title: i18n.messages.value[locale]?.meta?.name ?? locale, // there may be a better way to do this, but I couldn't figure it out
//   }
// })

// const timezoneOptions = moment.tz.names().map((timezone) => {
//   return {
//     value: timezone,
//     title: timezone,
//   }
// })

/**
 * We can't put these watchers in PreferenceService, because watch() can only
 * be called from within a Vue setup function (such as this file).
 */

watch(() => PreferencesService.preferences.darkMode, (darkMode) => {
  PreferencesService.savePreference('darkMode', darkMode ? '1' : '0')  
  theme.global.name.value = darkMode ? 'dark' : 'light'
})

watch(() => PreferencesService.preferences.locale, (locale) => {
  i18n.locale.value = locale
  PreferencesService.savePreference('locale', locale) 
})

watch(() => PreferencesService.preferences.timezone, (timezone) => {
  PreferencesService.savePreference('timezone', timezone) 
})

watch(() => PreferencesService.preferences.showIds, (showIds) => {
  PreferencesService.savePreference('showIds', showIds ? '1' : '0')
})

</script>
